import React from 'react';
import PropTypes from 'prop-types';
import PageError from '../pages/error/pageError';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //Reset of the state so that the menu continues to operate
        if (this.props.location !== prevProps.location) {
            this.setState({
                error: null
            });
        }
    }
    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary.componentDidCatch', error, errorInfo);
        // If a crash happens during the initial load of the app, we want to remove the
        // loading animation that's obstructing the real app.
        document.getElementById('initial-loader')?.remove();
        // We used to report errors to sentry here, however the extras we added were always
        // missing. It turns out that even without this block, the errors are reported the same.
        // I assume that this is because the error were caught somewhere else automatically by
        // sentry, and what we captured here was considered a duplicate.
        // It would be nice to fix this to get the error info component stack, but the
        // component names are minified anyway so that would not be very helpful.
        //     Sentry.withScope(scope => {
        //         scope.setExtras(errorInfo);
        //         scope.setExtra('captured_by', 'ErrorBoundary');
        //         scope.captureException(error);
        //         console.log('Sent exception to sentry');
        //     });
    }

    render() {
        const { error } = this.state;
        if (error) {
            // ⚠️ do not call our API when rendering the error, otherwise the error page may
            // cause another error to happen, and we would run in a loop, DDOSing our own servers.
            return <PageError backHomeUrl={this.props.backHomeUrl || `/ticket/`} error={error} />;
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node
};
